import { Card } from "primereact/card";
import React from "react";
import { Select, Tooltip } from "../../../../../../components/core";
import { InputNumber } from "primereact/inputnumber";
import { Divider } from "primereact/divider";
import TextFieldDropdown from "../../../../../../components/core/text-field-with-dropdown";
import { Column } from "primereact/column";
import CustomTextField from "../../../../../../components/core/custom-text-field";
import { DataTable } from "primereact/datatable";
import { useSelector } from "react-redux";

const BehavioralCampaignDetails = ({
	behavioralVars,
	handleChange,
	behaviorTypeList,
	durationOptions,
	behaviorParameterList,
	addButtonTemplate,

	behaviorTypeLabel,
	actionTemplate,
}) => {
	const accessPermission = useSelector(
		(state) => state.accessPermissions.accessPermissions
	);
	const defaultHeaders = [
		{
			header: behaviorTypeLabel || "Reward Parameter",
			field: "parameterValue",
			// key: "params_name",
			sortable: "true",
		},
		{
			header: "MBOX Coins to be Earned",
			field: "coins_value",
			// key: "coins_value",
			sortable: "true",
		},
	];

	return (
		<div>
			<Card className="bg-[#F8EED4] font-montserrat">
				<div className="font-bold text-black text-lg  ">Campaign Details:</div>

				<div className="flex flex-col gap-3 px-2">
					<div className="grid grid-cols-6 items-center">
						<label className="col-span-1 flex items-center">
							<Tooltip
								icon2={"pi pi-question-circle"}
								className={"pr-1 items-center mt-0"}
								message={
									<div>
										<p className="font-bold text-orange-400">
											Campaign Redemption Limit:
										</p>
										<p className="indent-5">
											Total number of times the code could be redeemed
											throughout the whole campaign period.{" "}
										</p>
										<div className="my-4"></div>
										<p className="font-bold text-orange-400">
											Per person Redemption Limit:
										</p>
										<p className="indent-5">
											Total number of times the could could be redeemed{" "}
											<i>
												<b>per mobile number</b>
											</i>{" "}
											thoughout the whole campaign period.
										</p>

										<div className="my-6"></div>

										<p>
											Note: Setting the limit to "0" will make the redemption
											code unlimited use.
										</p>
									</div>
								}
							></Tooltip>
							Redemption Limit
						</label>

						<div className="col-span-5 space-y-2">
							<div className="grid grid-cols-8 items-center">
								<label className="col-span-1">Campaign:</label>
								<InputNumber
									showButtons={
										accessPermission.behavioralCampaign === 1 ||
										accessPermission.behavioralCampaign === "1"
											? false
											: true
									}
									readOnly={
										accessPermission.behavioralCampaign === 1 ||
										accessPermission.behavioralCampaign === "1"
									}
									className="w-full col-span-2"
									buttonLayout="horizontal"
									prefix={
										behavioralVars.redemptionLimit.campaign < 1 &&
										behavioralVars.redemptionLimit.campaign !== null
											? "no limit ("
											: null
									}
									suffix={
										behavioralVars.redemptionLimit.campaign < 1 &&
										behavioralVars.redemptionLimit.campaign !== null
											? ")"
											: null
									}
									step={1}
									// readOnly={isReadonly}
									min={0}
									max={99999}
									maxLength={5}
									value={behavioralVars.redemptionLimit.campaign}
									// name="campaign"
									onValueChange={handleChange}
									name="redemptionLimit.campaign"
									incrementButtonIcon="pi pi-plus"
									decrementButtonIcon="pi pi-minus"
									pt={{
										incrementButton: {
											className: "bg-primary-primaryYellow",
										},
										decrementButton: {
											className: "bg-primary-primaryYellow",
										},
										root: {
											className:
												"border border-gray-200 rounded-lg w-full h-10",
										},
										//
									}}
								/>
							</div>

							<div className="grid grid-cols-8 items-center">
								<label className="col-span-1">Per person:</label>
								<InputNumber
									showButtons={
										accessPermission.behavioralCampaign === 1 ||
										accessPermission.behavioralCampaign === "1"
											? false
											: true
									}
									readOnly={
										accessPermission.behavioralCampaign === 1 ||
										accessPermission.behavioralCampaign === "1"
									}
									min={0}
									prefix={
										behavioralVars.redemptionLimit.person < 1 &&
										behavioralVars.redemptionLimit.person !== null
											? "no limit ("
											: null
									}
									suffix={
										behavioralVars.redemptionLimit.person < 1 &&
										behavioralVars.redemptionLimit.person !== null
											? ")"
											: null
									}
									onValueChange={handleChange}
									value={behavioralVars.redemptionLimit.person}
									name="redemptionLimit.person"
									className="w-full col-span-2"
									buttonLayout="horizontal"
									step={1}
									max={99999}
									maxLength={5}
									incrementButtonIcon="pi pi-plus"
									decrementButtonIcon="pi pi-minus"
									pt={{
										incrementButton: {
											className: "bg-primary-primaryYellow",
										},
										decrementButton: {
											className: "bg-primary-primaryYellow",
										},
										root: {
											className:
												"border border-gray-200 rounded-lg w-full h-10",
										},
									}}
								/>
							</div>
						</div>
					</div>

					<div className="grid grid-cols-12 items-center">
						<div className="col-span-6">
							<div className="grid grid-cols-6 items-center">
								<label className="col-span-2">
									<Tooltip
										icon2={"pi pi-question-circle"}
										className={"pr-1 items-center mt-0"}
										message={
											<div>
												<p className="font-bold text-orange-400">
													Early Pickup
												</p>
												<p className="indent-5">
													Reward users who pick up their parcel immediately
													after the drop off.
												</p>
												<p className="pt-2">
													Sample Reward Parameter:<br></br>
													<p className="indent-8">1 hour | 10 MBOX Coins</p>
													<p className="indent-8">2 hours | 5 MBOX Coins</p>
												</p>

												<p className="px-2">
													* Users who pick up their parcel{" "}
													<b>
														<i> within the first hour of the drop off time</i>{" "}
													</b>{" "}
													will receive 10 MBOX coins. <br></br>* Users who pick
													up their parcel{" "}
													<b>
														<i>
															within 1 hour and 1 minute to 2 hours after the
															drop off time
														</i>{" "}
													</b>
													will receive 5 MBOX coins.
												</p>
												<div className="my-4"></div>
												<p className="font-bold text-orange-400">
													Number of Packages Claimed
												</p>
												<p className="indent-5">
													Reward users who receive multiple packages using the
													locker.
												</p>
											</div>
										}
									></Tooltip>
									Rewarded Behavior:
								</label>

								<div className="col-span-4">
									<Select
										disabled={
											accessPermission.behavioralCampaign === 1 ||
											accessPermission.behavioralCampaign === "1"
										}
										items={behaviorTypeList}
										value={behavioralVars.rewardedBehavior}
										name={"rewardedBehavior"}
										onChange={handleChange}
										defaultOption={{
											value: -1,
											name: "-- Please select rewarded behavior --",
										}}
									/>
								</div>
							</div>
						</div>

						{behavioralVars.rewardedBehavior === "2" && (
							<>
								<div className="col-span-1">
									<Divider
										align="center"
										type="solid"
										className="custom-divider px-0"
										// className=" border-b border-gray-400 "
									>
										<span className="divider-label px-0">over</span>
									</Divider>
								</div>

								<div className="col-span-5">
									{/* <div>helo</div> */}
									<div className="grid grid-cols-8 items-center">
										<label className="col-span-3">
											<Tooltip
												icon2={"pi pi-question-circle"}
												className={"pr-1 pl-1 items-center mt-0"}
												message={
													<div>
														<p className="font-bold text-orange-400">
															Time Frame:
														</p>
														<p className="indent-5">
															Sets a time limit for users to meet the reward
															parameter criteria based on the specified rewarded
															behavior.
														</p>
														<p className="indent-5 mt-3">
															If no time frame is specified, the campaign date
															will be used by default.{" "}
														</p>
													</div>
												}
											/>
											Time Frame:
										</label>

										<div className="col-span-5">
											<TextFieldDropdown
												disabled={true}
												isDisabled={true}
												dropdownOptions={durationOptions}
												onChange={handleChange}
												minFractionDigits={0}
												onValueChange={handleChange}
												inputNumberName="behaviorReward.value"
												inputNumber={behavioralVars.behaviorReward.value}
												dropdownValueName="behaviorReward.behaviorRewardId"
												dropdownId={parseInt(
													behavioralVars.behaviorReward.behaviorRewardId
												)}
												placeholder="0"
											/>
										</div>
									</div>
								</div>
							</>
						)}
					</div>

					<div className="grid grid-cols-6 items-center">
						<div className="col-span-6">
							<div className="grid grid-cols-5 items-center">
								<label className="col-span-1">Reward Parameter:</label>
							</div>
							<div>
								<Card>
									<DataTable
										emptyMessage="No available reward parameter"
										rows={10}
										className="border"
										sortMode="multiple"
										stripedRows
										value={behaviorParameterList}
										removableSort
										showGridlines
										footer={addButtonTemplate()}
										// paginator
										// paginatorTemplate={paginatorTemplate}
										// paginatorPosition="bottom"
									>
										<Column
											header="#"
											className="text-center"
											body={(rowData, options) => options.rowIndex + 1}
											headerStyle={{
												width: "3rem",
												backgroundColor: "#FECD08",
											}}
										/>

										{defaultHeaders.map((column) => {
											return (
												<Column
													key={column.field}
													header={column.header}
													className="max-w-[350px]"
													field={column.field}
													// headerClassName="text-center font-bold justify-center"
													sortable={column.sortable}
													headerStyle={{
														backgroundColor: "#FECD08",
													}}
													body={(rowData, index) => {
														if (column.field === "parameterValue") {
															return (
																<CustomTextField
																	readOnly={
																		accessPermission.behavioralCampaign === 1 ||
																		accessPermission.behavioralCampaign === "1"
																	}
																	value={rowData[column.field]}
																	parametername={
																		behaviorTypeLabel === "Early Pickup"
																			? "hour/s after drop off"
																			: "packages"
																	}
																	name={"parameterValue"}
																	onValueChange={(event) =>
																		handleChange(event, rowData)
																	}
																	minFractionDigits={
																		behaviorTypeLabel === "Early Pickup" ? 2 : 0
																	}
																/>

																// <InputNumber
																// 	value={rowData[column.field]}
																// 	// parametername={
																// 	// 	behaviorTypeLabel === "Early Pickup"
																// 	// 		? "hour/s after drop off"
																// 	// 		: "packages"
																// 	// }
																// 	name={"parameterValue"}
																// 	// behaviorParameter={behaviorTypeLabel}
																// 	// key={rowData[column.index]}
																// 	onValueChange={(event) =>
																// 		handleChange(event, rowData)
																// 	}
																// />
															);
														} else if (column.field === "coins_value") {
															return (
																<CustomTextField
																	readOnly={
																		accessPermission.behavioralCampaign === 1 ||
																		accessPermission.behavioralCampaign === "1"
																	}
																	value={rowData[column.field]}
																	name={"coins_value"}
																	parametername={"MBOX coins"}
																	onValueChange={(event) =>
																		handleChange(event, rowData)
																	}
																	minFractionDigits={2}
																/>

																// <InputNumber
																// 	value={rowData[column.field]}
																// 	name={"coins_value"}
																// 	onValueChange={(event) =>
																// 		handleChange(event, rowData)
																// 	}
																// />
															);
														} else {
															return null;
														}
													}}

													// body={() => <div width="100%"> test</div>}
												/>
											);
										})}

										<Column
											header=""
											body={(rowData, index) =>
												actionTemplate(rowData, index.rowIndex)
											}
											headerStyle={{
												width: "3rem",
												backgroundColor: "#FECD08",
											}}
											hidden={
												accessPermission.behavioralCampaign === 1 ||
												accessPermission.behavioralCampaign === "1"
											}
										/>
									</DataTable>
								</Card>
							</div>
						</div>
					</div>
				</div>
			</Card>
		</div>
	);
};

export default BehavioralCampaignDetails;
